import { Routes, Route } from 'react-router-dom'

import Home from 'src/pages/Home';
import Post from 'src/pages/Post';
import Ranking from 'src/pages/Ranking';
import Securitiescompany from 'src/pages/Securitiescompany';
import Stock from 'src/pages/Stock';
import Blog from 'src/pages/Blog';
// import Hot from 'src/pages/Hot';
import Search from 'src/pages/Search';
import StockHome from 'src/pages/StockHome';


const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/post" element={<Post />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/securitiescompany" element={<Securitiescompany />} />
      <Route path="/stock" element={<Stock />} />
      <Route path="/blog" element={<Blog />} />
      {/* <Route path="/report" element={<Hot />} /> */}
      <Route path="/search" element={<Search />} />
      <Route path="/stock/:id" element={<StockHome />} />
    </Routes>
  );
};

export default Router
